import React, { useEffect, useState } from "react";

// Country flags as images (product UI never shows emoji): the open-source
// flag-icons set (MIT, public/flags/LICENSE), one SVG per listed country in
// public/flags/4x3 (list rows) and public/flags/1x1 (the round flag on the
// payout screens). Founder, 2026-10-19: "add the flags of all countries".
// An unknown code or a missing file shows a quiet grey tile, never a broken image.
const VALID = /^[A-Za-z]{2}$/;

export default function CountryFlag({ code, shape = "rect", className }: { code?: string | null; shape?: "rect" | "circle"; className?: string }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [code]);
  const cls = `cflag cflag-${shape}${className ? ` ${className}` : ""}`;
  if (!code || !VALID.test(code) || failed) return <span className={`${cls} cflag-blank`} aria-hidden="true" />;
  return (
    <img
      className={cls}
      src={`/flags/${shape === "circle" ? "1x1" : "4x3"}/${code.toLowerCase()}.svg`}
      alt=""
      aria-hidden="true"
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
